import { PortfolioUtilities as portfolioUtilities, PortfolioUtilities } from '../../common/portfolio.utilities';
class TransactionsGridController implements angular.IOnInit {

  public getData: () => (currency) => any;
  public accountId: number;
  public currencyCode: string;

  private gridOptions: any;

  /** @ngInject */
  constructor(private portfolioUtilities: portfolioUtilities, private $filter: any) {
  }


  $onInit() {
    // cannot set in cunstructor because binding has not yet happened
    this.gridOptions = {
      data: [],
      urlSync: false
    };

    this.getData()(this.accountId)
      .then((result) => {
        this.gridOptions.data = result.data;
      });
  }

  formatCurrency(value, isDrAmount) {
    if (!value)
      return '-';
    if (!this.currencyCode) {
      if (value >= 0 && !isDrAmount)
        return this.$filter('currency')(value, '', 2);
      else
        return `(${this.$filter('currency')(value, '', 2)})`;
    }
    if (value >= 0 && !isDrAmount)
      return this.$filter('currency')(value, this.portfolioUtilities.formatCurrency(this.currencyCode), 2);
    else
      return `(${this.$filter('currency')(value, this.portfolioUtilities.formatCurrency(this.currencyCode), 2)})`;
  }

}


export const transactionsGrid: angular.IComponentOptions = {
  template: require('./transactionsGrid.html'),
  controller: TransactionsGridController,
  bindings: {
    getData: "&",
    currencyCode: "<",
    accountId: "<"
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/components/transactionsGrid.ts